// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3F_Ns","cell":"ColumnAccessor_cell__MiO6o","firstCellAccent":"ColumnAccessor_firstCellAccent__37zeL"};